var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row && _vm.row.cliente && (_vm.row.cliente.ar_id == 7 || _vm.row.cliente.user_id == 7))?_c('b-button',{attrs:{"variant":`${_vm.isDataMenorQue15Dias() ? 'success': 'outline-secondary'}`,"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_c('i',{staticClass:"fab fa-whatsapp"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }